import { AuthorityWithConfig } from '../interfaces/authority';
import { useFleetsQuery } from '../queries';
import { useFleet } from './useFleet';

export const useAuthorities = (): AuthorityWithConfig[] => {
  const fleet = useFleet();

  return fleet.authorities ?? [];
};

export const useFleetAuthorities = (fleetId: number): AuthorityWithConfig[] => {
  const { data: fleets } = useFleetsQuery();
  const fleet = fleets?.find((f) => f.id === fleetId);
  return fleet?.authorities ?? [];
};

export const useCanFilterByAuthority = (): boolean => {
  const authorities = useAuthorities();

  return authorities.length > 1;
};
